module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bdec81b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom.vue
// module id = 141
// module chunks = 0